import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, PLATFORM_ID, Injectable, Inject, ViewChild, ViewChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import * as i1 from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { categories as categories$1, EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import * as i2$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
function AnchorsComponent_ng_template_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 3);
    i0.ɵɵlistener("click", function AnchorsComponent_ng_template_1_span_0_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const idx_r2 = i0.ɵɵnextContext().index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick($event, idx_r2));
    });
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 4);
    i0.ɵɵelement(3, "path");
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(4, "span", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("color", category_r4.name === ctx_r2.selected ? ctx_r2.color : null);
    i0.ɵɵclassProp("emoji-mart-anchor-selected", category_r4.name === ctx_r2.selected);
    i0.ɵɵattribute("title", ctx_r2.i18n.categories[category_r4.id]);
    i0.ɵɵadvance(3);
    i0.ɵɵattribute("d", ctx_r2.icons[category_r4.id]);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background-color", ctx_r2.color);
  }
}
function AnchorsComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AnchorsComponent_ng_template_1_span_0_Template, 5, 8, "span", 2);
  }
  if (rf & 2) {
    const category_r4 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", category_r4.anchor !== false);
  }
}
const _c0 = ["container"];
const _c1 = ["label"];
function CategoryComponent_div_6_div_1_ngx_emoji_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-emoji", 9);
    i0.ɵɵlistener("emojiOver", function CategoryComponent_div_6_div_1_ngx_emoji_1_Template_ngx_emoji_emojiOver_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.emojiOver.emit($event));
    })("emojiLeave", function CategoryComponent_div_6_div_1_ngx_emoji_1_Template_ngx_emoji_emojiLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.emojiLeave.emit($event));
    })("emojiClick", function CategoryComponent_div_6_div_1_ngx_emoji_1_Template_ngx_emoji_emojiClick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.emojiClick.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const emoji_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("emoji", emoji_r3)("size", ctx_r1.emojiSize)("skin", ctx_r1.emojiSkin)("isNative", ctx_r1.emojiIsNative)("set", ctx_r1.emojiSet)("sheetSize", ctx_r1.emojiSheetSize)("forceSize", ctx_r1.emojiForceSize)("tooltip", ctx_r1.emojiTooltip)("backgroundImageFn", ctx_r1.emojiBackgroundImageFn)("imageUrlFn", ctx_r1.emojiImageUrlFn)("hideObsolete", ctx_r1.hideObsolete)("useButton", ctx_r1.emojiUseButton);
  }
}
function CategoryComponent_div_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CategoryComponent_div_6_div_1_ngx_emoji_1_Template, 1, 12, "ngx-emoji", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const filteredEmojis_r4 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", filteredEmojis_r4)("ngForTrackBy", ctx_r1.trackById);
  }
}
function CategoryComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CategoryComponent_div_6_div_1_Template, 2, 2, "div", 7);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 1, ctx_r1.filteredEmojis$));
  }
}
function CategoryComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div");
    i0.ɵɵelement(2, "ngx-emoji", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("emoji", ctx_r1.notFoundEmoji)("size", 38)("skin", ctx_r1.emojiSkin)("isNative", ctx_r1.emojiIsNative)("set", ctx_r1.emojiSet)("sheetSize", ctx_r1.emojiSheetSize)("forceSize", ctx_r1.emojiForceSize)("tooltip", ctx_r1.emojiTooltip)("backgroundImageFn", ctx_r1.emojiBackgroundImageFn)("useButton", ctx_r1.emojiUseButton);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.i18n.notfound, " ");
  }
}
function CategoryComponent_ng_template_8_ngx_emoji_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ngx-emoji", 9);
    i0.ɵɵlistener("emojiOver", function CategoryComponent_ng_template_8_ngx_emoji_0_Template_ngx_emoji_emojiOver_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emojiOver.emit($event));
    })("emojiLeave", function CategoryComponent_ng_template_8_ngx_emoji_0_Template_ngx_emoji_emojiLeave_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emojiLeave.emit($event));
    })("emojiClick", function CategoryComponent_ng_template_8_ngx_emoji_0_Template_ngx_emoji_emojiClick_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.emojiClick.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const emoji_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("emoji", emoji_r6)("size", ctx_r1.emojiSize)("skin", ctx_r1.emojiSkin)("isNative", ctx_r1.emojiIsNative)("set", ctx_r1.emojiSet)("sheetSize", ctx_r1.emojiSheetSize)("forceSize", ctx_r1.emojiForceSize)("tooltip", ctx_r1.emojiTooltip)("backgroundImageFn", ctx_r1.emojiBackgroundImageFn)("imageUrlFn", ctx_r1.emojiImageUrlFn)("hideObsolete", ctx_r1.hideObsolete)("useButton", ctx_r1.emojiUseButton);
  }
}
function CategoryComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CategoryComponent_ng_template_8_ngx_emoji_0_Template, 1, 12, "ngx-emoji", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngForOf", ctx_r1.emojisToDisplay)("ngForTrackBy", ctx_r1.trackById);
  }
}
function SkinComponent_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 2)(1, "span", 3);
    i0.ɵɵlistener("click", function SkinComponent_span_1_Template_span_click_1_listener() {
      const skinTone_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick(skinTone_r2));
    })("keyup.enter", function SkinComponent_span_1_Template_span_keyup_enter_1_listener() {
      const skinTone_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick(skinTone_r2));
    })("keyup.space", function SkinComponent_span_1_Template_span_keyup_space_1_listener() {
      const skinTone_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleClick(skinTone_r2));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const skinTone_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("selected", skinTone_r2 === ctx_r2.skin);
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("emoji-mart-skin emoji-mart-skin-tone-", skinTone_r2, "");
    i0.ɵɵproperty("tabIndex", ctx_r2.tabIndex(skinTone_r2));
    i0.ɵɵattribute("aria-hidden", !ctx_r2.isVisible(skinTone_r2))("aria-pressed", ctx_r2.pressed(skinTone_r2))("aria-haspopup", !!ctx_r2.isSelected(skinTone_r2))("aria-expanded", ctx_r2.expanded(skinTone_r2))("aria-label", ctx_r2.i18n.skintones[skinTone_r2])("title", ctx_r2.i18n.skintones[skinTone_r2]);
  }
}
function PreviewComponent_div_0_span_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const short_name_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" :", short_name_r1, ": ");
  }
}
function PreviewComponent_div_0_span_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const emoticon_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", emoticon_r2, " ");
  }
}
function PreviewComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 2);
    i0.ɵɵelement(2, "ngx-emoji", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "div", 10);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 11);
    i0.ɵɵtemplate(7, PreviewComponent_div_0_span_7_Template, 2, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 13);
    i0.ɵɵtemplate(9, PreviewComponent_div_0_span_9_Template, 2, 1, "span", 14);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("emoji", ctx_r2.emoji)("size", 38)("isNative", ctx_r2.emojiIsNative)("skin", ctx_r2.emojiSkin)("size", ctx_r2.emojiSize)("set", ctx_r2.emojiSet)("sheetSize", ctx_r2.emojiSheetSize)("backgroundImageFn", ctx_r2.emojiBackgroundImageFn)("imageUrlFn", ctx_r2.emojiImageUrlFn);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.emojiData.name);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.emojiData.shortNames);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.listedEmoticons);
  }
}
function PreviewComponent_ngx_emoji_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-emoji", 16);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("isNative", ctx_r2.emojiIsNative)("skin", ctx_r2.emojiSkin)("set", ctx_r2.emojiSet)("emoji", ctx_r2.idleEmoji)("backgroundImageFn", ctx_r2.emojiBackgroundImageFn)("size", 38)("imageUrlFn", ctx_r2.emojiImageUrlFn);
  }
}
const _c2 = ["inputRef"];
const _c3 = ["scrollRef"];
function PickerComponent_emoji_search_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emoji-search", 8);
    i0.ɵɵlistener("searchResults", function PickerComponent_emoji_search_3_Template_emoji_search_searchResults_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleSearch($event));
    })("enterKey", function PickerComponent_emoji_search_3_Template_emoji_search_enterKey_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEnterKey($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("i18n", ctx_r2.i18n)("include", ctx_r2.include)("exclude", ctx_r2.exclude)("custom", ctx_r2.custom)("autoFocus", ctx_r2.autoFocus)("icons", ctx_r2.searchIcons)("emojisToShowFilter", ctx_r2.emojisToShowFilter);
  }
}
function PickerComponent_emoji_category_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emoji-category", 9);
    i0.ɵɵlistener("emojiOver", function PickerComponent_emoji_category_6_Template_emoji_category_emojiOver_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEmojiOver($event));
    })("emojiLeave", function PickerComponent_emoji_category_6_Template_emoji_category_emojiLeave_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEmojiLeave());
    })("emojiClick", function PickerComponent_emoji_category_6_Template_emoji_category_emojiClick_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleEmojiClick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", category_r5.id)("name", category_r5.name)("emojis", category_r5.emojis)("perLine", ctx_r2.perLine)("totalFrequentLines", ctx_r2.totalFrequentLines)("hasStickyPosition", ctx_r2.isNative)("i18n", ctx_r2.i18n)("hideObsolete", ctx_r2.hideObsolete)("notFoundEmoji", ctx_r2.notFoundEmoji)("custom", category_r5.id === ctx_r2.RECENT_CATEGORY.id ? ctx_r2.CUSTOM_CATEGORY.emojis : undefined)("recent", category_r5.id === ctx_r2.RECENT_CATEGORY.id ? ctx_r2.recent : undefined)("virtualize", ctx_r2.virtualize)("virtualizeOffset", ctx_r2.virtualizeOffset)("emojiIsNative", ctx_r2.isNative)("emojiSkin", ctx_r2.skin)("emojiSize", ctx_r2.emojiSize)("emojiSet", ctx_r2.set)("emojiSheetSize", ctx_r2.sheetSize)("emojiForceSize", ctx_r2.isNative)("emojiTooltip", ctx_r2.emojiTooltip)("emojiBackgroundImageFn", ctx_r2.backgroundImageFn)("emojiImageUrlFn", ctx_r2.imageUrlFn)("emojiUseButton", ctx_r2.useButton);
  }
}
function PickerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "emoji-preview", 10);
    i0.ɵɵlistener("skinChange", function PickerComponent_div_7_Template_emoji_preview_skinChange_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleSkinChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("emoji", ctx_r2.previewEmoji)("idleEmoji", ctx_r2.emoji)("emojiIsNative", ctx_r2.isNative)("emojiSize", 38)("emojiSkin", ctx_r2.skin)("emojiSet", ctx_r2.set)("i18n", ctx_r2.i18n)("emojiSheetSize", ctx_r2.sheetSize)("emojiBackgroundImageFn", ctx_r2.backgroundImageFn)("emojiImageUrlFn", ctx_r2.imageUrlFn);
    i0.ɵɵattribute("title", ctx_r2.title);
  }
}
let AnchorsComponent = /*#__PURE__*/(() => {
  class AnchorsComponent {
    constructor() {
      this.categories = [];
      this.icons = {};
      this.anchorClick = new EventEmitter();
    }
    trackByFn(idx, cat) {
      return cat.id;
    }
    handleClick($event, index) {
      this.anchorClick.emit({
        category: this.categories[index],
        index
      });
    }
  }
  AnchorsComponent.ɵfac = function AnchorsComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AnchorsComponent)();
  };
  AnchorsComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: AnchorsComponent,
    selectors: [["emoji-mart-anchors"]],
    inputs: {
      categories: "categories",
      color: "color",
      selected: "selected",
      i18n: "i18n",
      icons: "icons"
    },
    outputs: {
      anchorClick: "anchorClick"
    },
    decls: 2,
    vars: 2,
    consts: [[1, "emoji-mart-anchors"], ["ngFor", "", 3, "ngForOf", "ngForTrackBy"], ["class", "emoji-mart-anchor", 3, "emoji-mart-anchor-selected", "color", "click", 4, "ngIf"], [1, "emoji-mart-anchor", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", "width", "24", "height", "24"], [1, "emoji-mart-anchor-bar"]],
    template: function AnchorsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, AnchorsComponent_ng_template_1_Template, 1, 1, "ng-template", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.categories)("ngForTrackBy", ctx.trackByFn);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf],
    encapsulation: 2,
    changeDetection: 0
  });
  return AnchorsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmojiFrequentlyService = /*#__PURE__*/(() => {
  class EmojiFrequentlyService {
    constructor(platformId) {
      this.platformId = platformId;
      this.NAMESPACE = 'emoji-mart';
      this.frequently = null;
      this.defaults = {};
      this.initialized = false;
      this.DEFAULTS = ['+1', 'grinning', 'kissing_heart', 'heart_eyes', 'laughing', 'stuck_out_tongue_winking_eye', 'sweat_smile', 'joy', 'scream', 'disappointed', 'unamused', 'weary', 'sob', 'sunglasses', 'heart', 'poop'];
    }
    init() {
      this.frequently = JSON.parse(isPlatformBrowser(this.platformId) && localStorage.getItem(`${this.NAMESPACE}.frequently`) || 'null');
      this.initialized = true;
    }
    add(emoji) {
      if (!this.initialized) {
        this.init();
      }
      if (!this.frequently) {
        this.frequently = this.defaults;
      }
      if (!this.frequently[emoji.id]) {
        this.frequently[emoji.id] = 0;
      }
      this.frequently[emoji.id] += 1;
      if (isPlatformBrowser(this.platformId)) {
        localStorage.setItem(`${this.NAMESPACE}.last`, emoji.id);
        localStorage.setItem(`${this.NAMESPACE}.frequently`, JSON.stringify(this.frequently));
      }
    }
    get(perLine, totalLines) {
      if (!this.initialized) {
        this.init();
      }
      if (this.frequently === null) {
        this.defaults = {};
        const result = [];
        for (let i = 0; i < perLine; i++) {
          this.defaults[this.DEFAULTS[i]] = perLine - i;
          result.push(this.DEFAULTS[i]);
        }
        return result;
      }
      const quantity = perLine * totalLines;
      const frequentlyKeys = Object.keys(this.frequently);
      const sorted = frequentlyKeys.sort((a, b) => this.frequently[a] - this.frequently[b]).reverse();
      const sliced = sorted.slice(0, quantity);
      const last = isPlatformBrowser(this.platformId) && localStorage.getItem(`${this.NAMESPACE}.last`);
      if (last && !sliced.includes(last)) {
        sliced.pop();
        sliced.push(last);
      }
      return sliced;
    }
  }
  EmojiFrequentlyService.ɵfac = function EmojiFrequentlyService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmojiFrequentlyService)(i0.ɵɵinject(PLATFORM_ID));
  };
  EmojiFrequentlyService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmojiFrequentlyService,
    factory: EmojiFrequentlyService.ɵfac,
    providedIn: 'root'
  });
  return EmojiFrequentlyService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CategoryComponent = /*#__PURE__*/(() => {
  class CategoryComponent {
    constructor(ref, emojiService, frequently) {
      this.ref = ref;
      this.emojiService = emojiService;
      this.frequently = frequently;
      this.emojis = null;
      this.hasStickyPosition = true;
      this.name = '';
      this.perLine = 9;
      this.totalFrequentLines = 4;
      this.recent = [];
      this.custom = [];
      this.hideObsolete = true;
      this.virtualize = false;
      this.virtualizeOffset = 0;
      this.emojiOver = new EventEmitter();
      this.emojiLeave = new EventEmitter();
      this.emojiClick = new EventEmitter();
      this.containerStyles = {};
      this.emojisToDisplay = [];
      this.filteredEmojisSubject = new Subject();
      this.filteredEmojis$ = this.filteredEmojisSubject.asObservable();
      this.labelStyles = {};
      this.labelSpanStyles = {};
      this.margin = 0;
      this.minMargin = 0;
      this.maxMargin = 0;
      this.top = 0;
      this.rows = 0;
    }
    ngOnInit() {
      this.updateRecentEmojis();
      this.emojisToDisplay = this.filterEmojis();
      if (this.noEmojiToDisplay) {
        this.containerStyles = {
          display: 'none'
        };
      }
      if (!this.hasStickyPosition) {
        this.labelStyles = {
          height: 28
        };
        // this.labelSpanStyles = { position: 'absolute' };
      }
    }
    ngOnChanges(changes) {
      if (changes.emojis?.currentValue?.length !== changes.emojis?.previousValue?.length) {
        this.emojisToDisplay = this.filterEmojis();
        this.ngAfterViewInit();
      }
    }
    ngAfterViewInit() {
      if (!this.virtualize) {
        return;
      }
      const {
        width
      } = this.container.nativeElement.getBoundingClientRect();
      const perRow = Math.floor(width / (this.emojiSize + 12));
      this.rows = Math.ceil(this.emojisToDisplay.length / perRow);
      this.containerStyles = {
        ...this.containerStyles,
        minHeight: `${this.rows * (this.emojiSize + 12) + 28}px`
      };
      this.ref?.detectChanges();
      this.handleScroll(this.container.nativeElement.parentNode.parentNode.scrollTop);
    }
    get noEmojiToDisplay() {
      return this.emojisToDisplay.length === 0;
    }
    memoizeSize() {
      const parent = this.container.nativeElement.parentNode.parentNode;
      const {
        top,
        height
      } = this.container.nativeElement.getBoundingClientRect();
      const parentTop = parent.getBoundingClientRect().top;
      const labelHeight = this.label.nativeElement.getBoundingClientRect().height;
      this.top = top - parentTop + parent.scrollTop;
      if (height === 0) {
        this.maxMargin = 0;
      } else {
        this.maxMargin = height - labelHeight;
      }
    }
    handleScroll(scrollTop) {
      let margin = scrollTop - this.top;
      margin = margin < this.minMargin ? this.minMargin : margin;
      margin = margin > this.maxMargin ? this.maxMargin : margin;
      if (this.virtualize) {
        const {
          top,
          height
        } = this.container.nativeElement.getBoundingClientRect();
        const parentHeight = this.container.nativeElement.parentNode.parentNode.clientHeight;
        if (parentHeight + (parentHeight + this.virtualizeOffset) >= top && -height - (parentHeight + this.virtualizeOffset) <= top) {
          this.filteredEmojisSubject.next(this.emojisToDisplay);
        } else {
          this.filteredEmojisSubject.next([]);
        }
      }
      if (margin === this.margin) {
        this.ref.detectChanges();
        return false;
      }
      if (!this.hasStickyPosition) {
        this.label.nativeElement.style.top = `${margin}px`;
      }
      this.margin = margin;
      this.ref.detectChanges();
      return true;
    }
    updateRecentEmojis() {
      if (this.name !== 'Recent') {
        return;
      }
      let frequentlyUsed = this.recent || this.frequently.get(this.perLine, this.totalFrequentLines);
      if (!frequentlyUsed || !frequentlyUsed.length) {
        frequentlyUsed = this.frequently.get(this.perLine, this.totalFrequentLines);
      }
      if (!frequentlyUsed.length) {
        return;
      }
      this.emojis = frequentlyUsed.map(id => {
        const emoji = this.custom.filter(e => e.id === id)[0];
        if (emoji) {
          return emoji;
        }
        return id;
      }).filter(id => !!this.emojiService.getData(id));
    }
    updateDisplay(display) {
      this.containerStyles.display = display;
      this.updateRecentEmojis();
      this.ref.detectChanges();
    }
    trackById(index, item) {
      return item;
    }
    filterEmojis() {
      const newEmojis = [];
      for (const emoji of this.emojis || []) {
        if (!emoji) {
          continue;
        }
        const data = this.emojiService.getData(emoji);
        if (!data || data.obsoletedBy && this.hideObsolete || !data.unified && !data.custom) {
          continue;
        }
        newEmojis.push(emoji);
      }
      return newEmojis;
    }
  }
  CategoryComponent.ɵfac = function CategoryComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CategoryComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.EmojiService), i0.ɵɵdirectiveInject(EmojiFrequentlyService));
  };
  CategoryComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CategoryComponent,
    selectors: [["emoji-category"]],
    viewQuery: function CategoryComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
        i0.ɵɵviewQuery(_c1, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.label = _t.first);
      }
    },
    inputs: {
      emojis: "emojis",
      hasStickyPosition: "hasStickyPosition",
      name: "name",
      perLine: "perLine",
      totalFrequentLines: "totalFrequentLines",
      recent: "recent",
      custom: "custom",
      i18n: "i18n",
      id: "id",
      hideObsolete: "hideObsolete",
      notFoundEmoji: "notFoundEmoji",
      virtualize: "virtualize",
      virtualizeOffset: "virtualizeOffset",
      emojiIsNative: "emojiIsNative",
      emojiSkin: "emojiSkin",
      emojiSize: "emojiSize",
      emojiSet: "emojiSet",
      emojiSheetSize: "emojiSheetSize",
      emojiForceSize: "emojiForceSize",
      emojiTooltip: "emojiTooltip",
      emojiBackgroundImageFn: "emojiBackgroundImageFn",
      emojiImageUrlFn: "emojiImageUrlFn",
      emojiUseButton: "emojiUseButton"
    },
    outputs: {
      emojiOver: "emojiOver",
      emojiLeave: "emojiLeave",
      emojiClick: "emojiClick"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 10,
    vars: 11,
    consts: [["container", ""], ["label", ""], ["normalRenderTemplate", ""], [1, "emoji-mart-category", 3, "ngStyle"], [1, "emoji-mart-category-label", 3, "ngStyle"], ["aria-hidden", "true", 3, "ngStyle"], [4, "ngIf", "ngIfElse"], [4, "ngIf"], [3, "emoji", "size", "skin", "isNative", "set", "sheetSize", "forceSize", "tooltip", "backgroundImageFn", "imageUrlFn", "hideObsolete", "useButton", "emojiOver", "emojiLeave", "emojiClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "emojiOver", "emojiLeave", "emojiClick", "emoji", "size", "skin", "isNative", "set", "sheetSize", "forceSize", "tooltip", "backgroundImageFn", "imageUrlFn", "hideObsolete", "useButton"], [3, "emoji", "size", "skin", "isNative", "set", "sheetSize", "forceSize", "tooltip", "backgroundImageFn", "useButton"], [1, "emoji-mart-no-results-label"]],
    template: function CategoryComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 3, 0)(2, "div", 4)(3, "span", 5, 1);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(6, CategoryComponent_div_6_Template, 3, 3, "div", 6)(7, CategoryComponent_div_7_Template, 5, 11, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, CategoryComponent_ng_template_8_Template, 1, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const normalRenderTemplate_r7 = i0.ɵɵreference(9);
        i0.ɵɵclassProp("emoji-mart-no-results", ctx.noEmojiToDisplay);
        i0.ɵɵproperty("ngStyle", ctx.containerStyles);
        i0.ɵɵattribute("aria-label", ctx.i18n.categories[ctx.id]);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", ctx.labelStyles);
        i0.ɵɵattribute("data-name", ctx.name);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", ctx.labelSpanStyles);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.i18n.categories[ctx.id], " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.virtualize)("ngIfElse", normalRenderTemplate_r7);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.noEmojiToDisplay);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i2.NgStyle, i1.EmojiComponent, i2.AsyncPipe],
    encapsulation: 2,
    changeDetection: 0
  });
  return CategoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function uniq(arr) {
  return arr.reduce((acc, item) => {
    if (!acc.includes(item)) {
      acc.push(item);
    }
    return acc;
  }, []);
}
function intersect(a, b) {
  const uniqA = uniq(a);
  const uniqB = uniq(b);
  return uniqA.filter(item => uniqB.indexOf(item) >= 0);
}
// https://github.com/sonicdoe/measure-scrollbar
function measureScrollbar() {
  if (typeof document === 'undefined') {
    return 0;
  }
  const div = document.createElement('div');
  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  return scrollbarWidth;
}
let EmojiSearch = /*#__PURE__*/(() => {
  class EmojiSearch {
    constructor(emojiService) {
      this.emojiService = emojiService;
      this.originalPool = {};
      this.index = {};
      this.emojisList = {};
      this.emoticonsList = {};
      this.emojiSearch = {};
      for (const emojiData of this.emojiService.emojis) {
        const {
          shortNames,
          emoticons
        } = emojiData;
        const id = shortNames[0];
        for (const emoticon of emoticons) {
          if (this.emoticonsList[emoticon]) {
            continue;
          }
          this.emoticonsList[emoticon] = id;
        }
        this.emojisList[id] = this.emojiService.getSanitizedData(id);
        this.originalPool[id] = emojiData;
      }
    }
    addCustomToPool(custom, pool) {
      for (const emoji of custom) {
        const emojiId = emoji.id || emoji.shortNames[0];
        if (emojiId && !pool[emojiId]) {
          pool[emojiId] = this.emojiService.getData(emoji);
          this.emojisList[emojiId] = this.emojiService.getSanitizedData(emoji);
        }
      }
    }
    search(value, emojisToShowFilter, maxResults = 75, include = [], exclude = [], custom = []) {
      this.addCustomToPool(custom, this.originalPool);
      let results;
      let pool = this.originalPool;
      if (value.length) {
        if (value === '-' || value === '-1') {
          return [this.emojisList['-1']];
        }
        if (value === '+' || value === '+1') {
          return [this.emojisList['+1']];
        }
        let values = value.toLowerCase().split(/[\s|,|\-|_]+/);
        let allResults = [];
        if (values.length > 2) {
          values = [values[0], values[1]];
        }
        if (include.length || exclude.length) {
          pool = {};
          for (const category of categories$1 || []) {
            const isIncluded = include && include.length ? include.indexOf(category.id) > -1 : true;
            const isExcluded = exclude && exclude.length ? exclude.indexOf(category.id) > -1 : false;
            if (!isIncluded || isExcluded) {
              continue;
            }
            for (const emojiId of category.emojis || []) {
              // Need to make sure that pool gets keyed
              // with the correct id, which is why we call emojiService.getData below
              const emoji = this.emojiService.getData(emojiId);
              pool[emoji?.id ?? ''] = emoji;
            }
          }
          if (custom.length) {
            const customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
            const customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
            if (customIsIncluded && !customIsExcluded) {
              this.addCustomToPool(custom, pool);
            }
          }
        }
        allResults = values.map(v => {
          let aPool = pool;
          let aIndex = this.index;
          let length = 0;
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let charIndex = 0; charIndex < v.length; charIndex++) {
            const char = v[charIndex];
            length++;
            if (!aIndex[char]) {
              aIndex[char] = {};
            }
            aIndex = aIndex[char];
            if (!aIndex.results) {
              const scores = {};
              aIndex.results = [];
              aIndex.pool = {};
              for (const id of Object.keys(aPool)) {
                const emoji = aPool[id];
                if (!this.emojiSearch[id]) {
                  this.emojiSearch[id] = this.buildSearch(emoji.short_names, emoji.name, emoji.id, emoji.keywords, emoji.emoticons);
                }
                const query = this.emojiSearch[id];
                const sub = v.substr(0, length);
                const subIndex = query.indexOf(sub);
                if (subIndex !== -1) {
                  let score = subIndex + 1;
                  if (sub === id) {
                    score = 0;
                  }
                  aIndex.results.push(this.emojisList[id]);
                  aIndex.pool[id] = emoji;
                  scores[id] = score;
                }
              }
              aIndex.results.sort((a, b) => {
                const aScore = scores[a.id];
                const bScore = scores[b.id];
                return aScore - bScore;
              });
            }
            aPool = aIndex.pool;
          }
          return aIndex.results;
        }).filter(a => a);
        if (allResults.length > 1) {
          results = intersect.apply(null, allResults);
        } else if (allResults.length) {
          results = allResults[0];
        } else {
          results = [];
        }
      }
      if (results) {
        if (emojisToShowFilter) {
          results = results.filter(result => {
            if (result && result.id) {
              return emojisToShowFilter(this.emojiService.names[result.id]);
            }
            return false;
          });
        }
        if (results && results.length > maxResults) {
          results = results.slice(0, maxResults);
        }
      }
      return results || null;
    }
    buildSearch(shortNames, name, id, keywords, emoticons) {
      const search = [];
      const addToSearch = (strings, split) => {
        if (!strings) {
          return;
        }
        const arr = Array.isArray(strings) ? strings : [strings];
        for (const str of arr) {
          const substrings = split ? str.split(/[-|_|\s]+/) : [str];
          for (let s of substrings) {
            s = s.toLowerCase();
            if (!search.includes(s)) {
              search.push(s);
            }
          }
        }
      };
      addToSearch(shortNames, true);
      addToSearch(name, true);
      addToSearch(id, true);
      addToSearch(keywords, true);
      addToSearch(emoticons, false);
      return search.join(',');
    }
  }
  EmojiSearch.ɵfac = function EmojiSearch_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmojiSearch)(i0.ɵɵinject(i1.EmojiService));
  };
  EmojiSearch.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmojiSearch,
    factory: EmojiSearch.ɵfac,
    providedIn: 'root'
  });
  return EmojiSearch;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SkinComponent = /*#__PURE__*/(() => {
  class SkinComponent {
    constructor() {
      this.changeSkin = new EventEmitter();
      this.opened = false;
      this.skinTones = [1, 2, 3, 4, 5, 6];
    }
    toggleOpen() {
      this.opened = !this.opened;
    }
    isSelected(skinTone) {
      return skinTone === this.skin;
    }
    isVisible(skinTone) {
      return this.opened || this.isSelected(skinTone);
    }
    pressed(skinTone) {
      return this.opened ? !!this.isSelected(skinTone) : '';
    }
    tabIndex(skinTone) {
      return this.isVisible(skinTone) ? '0' : '';
    }
    expanded(skinTone) {
      return this.isSelected(skinTone) ? this.opened : '';
    }
    handleClick(skin) {
      if (!this.opened) {
        this.opened = true;
        return;
      }
      this.opened = false;
      if (skin !== this.skin) {
        this.changeSkin.emit(skin);
      }
    }
  }
  SkinComponent.ɵfac = function SkinComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SkinComponent)();
  };
  SkinComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SkinComponent,
    selectors: [["emoji-skins"]],
    inputs: {
      skin: "skin",
      i18n: "i18n"
    },
    outputs: {
      changeSkin: "changeSkin"
    },
    decls: 2,
    vars: 3,
    consts: [[1, "emoji-mart-skin-swatches"], ["class", "emoji-mart-skin-swatch", 3, "selected", 4, "ngFor", "ngForOf"], [1, "emoji-mart-skin-swatch"], ["role", "button", 3, "click", "keyup.enter", "keyup.space", "tabIndex"]],
    template: function SkinComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "section", 0);
        i0.ɵɵtemplate(1, SkinComponent_span_1_Template, 2, 12, "span", 1);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassProp("opened", ctx.opened);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.skinTones);
      }
    },
    dependencies: [i2.NgForOf],
    encapsulation: 2,
    changeDetection: 0
  });
  return SkinComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PreviewComponent = /*#__PURE__*/(() => {
  class PreviewComponent {
    constructor(ref, emojiService) {
      this.ref = ref;
      this.emojiService = emojiService;
      this.skinChange = new EventEmitter();
      this.emojiData = {};
    }
    ngOnChanges() {
      if (!this.emoji) {
        return;
      }
      this.emojiData = this.emojiService.getData(this.emoji, this.emojiSkin, this.emojiSet);
      const knownEmoticons = [];
      const listedEmoticons = [];
      const emoitcons = this.emojiData.emoticons || [];
      emoitcons.forEach(emoticon => {
        if (knownEmoticons.indexOf(emoticon.toLowerCase()) >= 0) {
          return;
        }
        knownEmoticons.push(emoticon.toLowerCase());
        listedEmoticons.push(emoticon);
      });
      this.listedEmoticons = listedEmoticons;
      this.ref?.detectChanges();
    }
  }
  PreviewComponent.ɵfac = function PreviewComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PreviewComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.EmojiService));
  };
  PreviewComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PreviewComponent,
    selectors: [["emoji-preview"]],
    inputs: {
      title: "title",
      emoji: "emoji",
      idleEmoji: "idleEmoji",
      i18n: "i18n",
      emojiIsNative: "emojiIsNative",
      emojiSkin: "emojiSkin",
      emojiSize: "emojiSize",
      emojiSet: "emojiSet",
      emojiSheetSize: "emojiSheetSize",
      emojiBackgroundImageFn: "emojiBackgroundImageFn",
      emojiImageUrlFn: "emojiImageUrlFn"
    },
    outputs: {
      skinChange: "skinChange"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 9,
    vars: 6,
    consts: [["class", "emoji-mart-preview", 4, "ngIf"], [1, "emoji-mart-preview", 3, "hidden"], [1, "emoji-mart-preview-emoji"], [3, "isNative", "skin", "set", "emoji", "backgroundImageFn", "size", "imageUrlFn", 4, "ngIf"], [1, "emoji-mart-preview-data"], [1, "emoji-mart-title-label"], [1, "emoji-mart-preview-skins"], [3, "changeSkin", "skin", "i18n"], [1, "emoji-mart-preview"], [3, "emoji", "size", "isNative", "skin", "set", "sheetSize", "backgroundImageFn", "imageUrlFn"], [1, "emoji-mart-preview-name"], [1, "emoji-mart-preview-shortname"], ["class", "emoji-mart-preview-shortname", 4, "ngFor", "ngForOf"], [1, "emoji-mart-preview-emoticons"], ["class", "emoji-mart-preview-emoticon", 4, "ngFor", "ngForOf"], [1, "emoji-mart-preview-emoticon"], [3, "isNative", "skin", "set", "emoji", "backgroundImageFn", "size", "imageUrlFn"]],
    template: function PreviewComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, PreviewComponent_div_0_Template, 10, 12, "div", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
        i0.ɵɵtemplate(3, PreviewComponent_ngx_emoji_3_Template, 1, 7, "ngx-emoji", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4)(5, "span", 5);
        i0.ɵɵtext(6);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 6)(8, "emoji-skins", 7);
        i0.ɵɵlistener("changeSkin", function PreviewComponent_Template_emoji_skins_changeSkin_8_listener($event) {
          return ctx.skinChange.emit($event);
        });
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.emoji && ctx.emojiData);
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.emoji);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.idleEmoji && ctx.idleEmoji.length);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.title);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("skin", ctx.emojiSkin)("i18n", ctx.i18n);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i1.EmojiComponent, SkinComponent],
    encapsulation: 2,
    changeDetection: 0
  });
  return PreviewComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let id = 0;
let SearchComponent = /*#__PURE__*/(() => {
  class SearchComponent {
    constructor(emojiSearch) {
      this.emojiSearch = emojiSearch;
      this.maxResults = 75;
      this.autoFocus = false;
      this.include = [];
      this.exclude = [];
      this.custom = [];
      this.searchResults = new EventEmitter();
      this.enterKey = new EventEmitter();
      this.isSearching = false;
      this.query = '';
      this.inputId = `emoji-mart-search-${++id}`;
    }
    ngOnInit() {
      this.icon = this.icons.search;
    }
    ngAfterViewInit() {
      if (this.autoFocus) {
        this.inputRef.nativeElement.focus();
      }
    }
    clear() {
      this.query = '';
      this.handleSearch('');
      this.inputRef.nativeElement.focus();
    }
    handleEnterKey($event) {
      if (!this.query) {
        return;
      }
      this.enterKey.emit($event);
      $event.preventDefault();
    }
    handleSearch(value) {
      if (value === '') {
        this.icon = this.icons.search;
        this.isSearching = false;
      } else {
        this.icon = this.icons.delete;
        this.isSearching = true;
      }
      const emojis = this.emojiSearch.search(this.query, this.emojisToShowFilter, this.maxResults, this.include, this.exclude, this.custom);
      this.searchResults.emit(emojis);
    }
    handleChange() {
      this.handleSearch(this.query);
    }
  }
  SearchComponent.ɵfac = function SearchComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SearchComponent)(i0.ɵɵdirectiveInject(EmojiSearch));
  };
  SearchComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SearchComponent,
    selectors: [["emoji-search"]],
    viewQuery: function SearchComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c2, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
      }
    },
    inputs: {
      maxResults: "maxResults",
      autoFocus: "autoFocus",
      i18n: "i18n",
      include: "include",
      exclude: "exclude",
      custom: "custom",
      icons: "icons",
      emojisToShowFilter: "emojisToShowFilter"
    },
    outputs: {
      searchResults: "searchResults",
      enterKey: "enterKey"
    },
    decls: 8,
    vars: 9,
    consts: [["inputRef", ""], [1, "emoji-mart-search"], ["type", "search", 3, "keyup.enter", "ngModelChange", "id", "placeholder", "autofocus", "ngModel"], [1, "emoji-mart-sr-only", 3, "htmlFor"], ["type", "button", 1, "emoji-mart-search-icon", 3, "click", "keyup.enter", "disabled"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 20 20", "width", "13", "height", "13", "opacity", "0.5"]],
    template: function SearchComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1)(1, "input", 2, 0);
        i0.ɵɵlistener("keyup.enter", function SearchComponent_Template_input_keyup_enter_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleEnterKey($event));
        });
        i0.ɵɵtwoWayListener("ngModelChange", function SearchComponent_Template_input_ngModelChange_1_listener($event) {
          i0.ɵɵrestoreView(_r1);
          i0.ɵɵtwoWayBindingSet(ctx.query, $event) || (ctx.query = $event);
          return i0.ɵɵresetView($event);
        });
        i0.ɵɵlistener("ngModelChange", function SearchComponent_Template_input_ngModelChange_1_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleChange());
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "button", 4);
        i0.ɵɵlistener("click", function SearchComponent_Template_button_click_5_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.clear());
        })("keyup.enter", function SearchComponent_Template_button_keyup_enter_5_listener() {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.clear());
        });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(6, "svg", 5);
        i0.ɵɵelement(7, "path");
        i0.ɵɵelementEnd()()();
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("id", ctx.inputId)("placeholder", ctx.i18n.search)("autofocus", ctx.autoFocus);
        i0.ɵɵtwoWayProperty("ngModel", ctx.query);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("htmlFor", ctx.inputId);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.i18n.search, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("disabled", !ctx.isSearching);
        i0.ɵɵattribute("aria-label", ctx.i18n.clear);
        i0.ɵɵadvance(2);
        i0.ɵɵattribute("d", ctx.icon);
      }
    },
    dependencies: [i2$1.DefaultValueAccessor, i2$1.NgControlStatus, i2$1.NgModel],
    encapsulation: 2
  });
  return SearchComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable  max-len */
const categories = {
  activity: `M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m10 11h-5c.3-2.5 1.3-4.8 2-6.1a10 10 0 0 1 3 6.1m-9 0V2a10 10 0 0 1 4.4 1.6A18 18 0 0 0 15 11h-2zm-2 0H9a18 18 0 0 0-2.4-7.4A10 10 0 0 1 11 2.1V11zm0 2v9a10 10 0 0 1-4.4-1.6A18 18 0 0 0 9 13h2zm4 0a18 18 0 0 0 2.4 7.4 10 10 0 0 1-4.4 1.5V13h2zM5 4.9c.7 1.3 1.7 3.6 2 6.1H2a10 10 0 0 1 3-6.1M2 13h5c-.3 2.5-1.3 4.8-2 6.1A10 10 0 0 1 2 13m17 6.1c-.7-1.3-1.7-3.6-2-6.1h5a10 10 0 0 1-3 6.1`,
  custom: `M10 1h3v21h-3zm10.186 4l1.5 2.598L3.5 18.098 2 15.5zM2 7.598L3.5 5l18.186 10.5-1.5 2.598z`,
  flags: `M0 0l6 24h2L2 0zm21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.6 3h7.8l2 8H8.6l-2-8zm8.8 10l-2.9 1.9-.4-1.9h3.3zm3.6 0l-1.5-6h2l2 8H16l3-2z`,
  foods: `M17 5c-1.8 0-2.9.4-3.7 1 .5-1.3 1.8-3 4.7-3a1 1 0 0 0 0-2c-3 0-4.6 1.3-5.5 2.5l-.2.2c-.6-1.9-1.5-3.7-3-3.7C8.5 0 7.7.3 7 1c-2 1.5-1.7 2.9-.5 4C3.6 5.2 0 7.4 0 13c0 4.6 5 11 9 11 2 0 2.4-.5 3-1 .6.5 1 1 3 1 4 0 9-6.4 9-11 0-6-4-8-7-8M8.2 2.5c.7-.5 1-.5 1-.5.4.2 1 1.4 1.4 3-1.6-.6-2.8-1.3-3-1.8l.6-.7M15 22c-1 0-1.2-.1-1.6-.4l-.1-.2a2 2 0 0 0-2.6 0l-.1.2c-.4.3-.5.4-1.6.4-2.8 0-7-5.4-7-9 0-6 4.5-6 5-6 2 0 2.5.4 3.4 1.2l.3.3a2 2 0 0 0 2.6 0l.3-.3c1-.8 1.5-1.2 3.4-1.2.5 0 5 .1 5 6 0 3.6-4.2 9-7 9`,
  nature: `M15.5 8a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m10.43-8h-.02c-.97 0-2.14.79-3.02 1.5A13.88 13.88 0 0 0 12 .99c-1.28 0-2.62.13-3.87.51C7.24.8 6.07 0 5.09 0h-.02C3.35 0 .07 2.67 0 7.03c-.04 2.47.28 4.23 1.04 5 .26.27.88.69 1.3.9.19 3.17.92 5.23 2.53 6.37.9.64 2.19.95 3.2 1.1-.03.2-.07.4-.07.6 0 1.77 2.35 3 4 3s4-1.23 4-3c0-.2-.04-.4-.07-.59 2.57-.38 5.43-1.87 5.92-7.58.4-.22.89-.57 1.1-.8.77-.76 1.09-2.52 1.05-5C23.93 2.67 20.65 0 18.93 0M3.23 9.13c-.24.29-.84 1.16-.9 1.24A9.67 9.67 0 0 1 2 7.08c.05-3.28 2.48-4.97 3.1-5.03.25.02.72.27 1.26.65A7.95 7.95 0 0 0 4 7.82c-.14.55-.4.86-.79 1.31M12 22c-.9 0-1.95-.7-2-1 0-.65.47-1.24 1-1.6v.6a1 1 0 1 0 2 0v-.6c.52.36 1 .95 1 1.6-.05.3-1.1 1-2 1m3-3.48v.02a4.75 4.75 0 0 0-1.26-1.02c1.09-.52 2.24-1.33 2.24-2.22 0-1.84-1.78-2.2-3.98-2.2s-3.98.36-3.98 2.2c0 .89 1.15 1.7 2.24 2.22A4.8 4.8 0 0 0 9 18.54v-.03a6.1 6.1 0 0 1-2.97-.84c-1.3-.92-1.84-3.04-1.86-6.48l.03-.04c.5-.82 1.49-1.45 1.8-3.1C6 6 7.36 4.42 8.36 3.53c1.01-.35 2.2-.53 3.59-.53 1.45 0 2.68.2 3.73.57 1 .9 2.32 2.46 2.32 4.48.31 1.65 1.3 2.27 1.8 3.1l.1.18c-.06 5.97-1.95 7.01-4.9 7.19m6.63-8.2l-.11-.2a7.59 7.59 0 0 0-.74-.98 3.02 3.02 0 0 1-.79-1.32 7.93 7.93 0 0 0-2.35-5.12c.53-.38 1-.63 1.26-.65.64.07 3.05 1.77 3.1 5.03.02 1.81-.35 3.22-.37 3.24`,
  objects: `M12 0a9 9 0 0 0-5 16.5V21s2 3 5 3 5-3 5-3v-4.5A9 9 0 0 0 12 0zm0 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM9 17.5a9 9 0 0 0 6 0v.8a7 7 0 0 1-3 .7 7 7 0 0 1-3-.7v-.8zm.2 3a8.9 8.9 0 0 0 2.8.5c1 0 1.9-.2 2.8-.5-.6.7-1.6 1.5-2.8 1.5-1.1 0-2.1-.8-2.8-1.5zm5.5-8.1c-.8 0-1.1-.8-1.5-1.8-.5-1-.7-1.5-1.2-1.5s-.8.5-1.3 1.5c-.4 1-.8 1.8-1.6 1.8h-.3c-.5-.2-.8-.7-1.3-1.8l-.2-1A3 3 0 0 0 7 9a1 1 0 0 1 0-2c1.7 0 2 1.4 2.2 2.1.5-1 1.3-2 2.8-2 1.5 0 2.3 1.1 2.7 2.1.2-.8.6-2.2 2.3-2.2a1 1 0 1 1 0 2c-.2 0-.3.5-.3.7a6.5 6.5 0 0 1-.3 1c-.5 1-.8 1.7-1.7 1.7`,
  people: `M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m0 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20M8 7a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-.8 8c-.7 1.2-1.8 2-3.3 2-1.5 0-2.7-.8-3.4-2H15m3-2H6a6 6 0 1 0 12 0`,
  places: `M6.5 12a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5m11-3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5m5-5.5l-1-.4-.1-.1h.6c.6 0 1-.4 1-1 0-1-.9-2-2-2h-.6l-.8-1.7A3 3 0 0 0 16.8 2H7.2a3 3 0 0 0-2.8 2.3L3.6 6H3a2 2 0 0 0-2 2c0 .6.4 1 1 1h.6v.1l-1 .4a2 2 0 0 0-1.4 2l.7 7.6a1 1 0 0 0 1 .9H3v1c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-1h6v1c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-1h1.1a1 1 0 0 0 1-.9l.7-7.5a2 2 0 0 0-1.3-2.1M6.3 4.9c.1-.5.5-.9 1-.9h9.5c.4 0 .8.4 1 .9L19.2 9H4.7l1.6-4.1zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.2-3H2.8l-.7-6.6.9-.4h18l.9.4-.7 6.6z`,
  recent: `M13 4h-2v7H9v2h2v2h2v-2h4v-2h-4zm-1-4a12 12 0 1 0 0 24 12 12 0 0 0 0-24m0 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20`,
  symbols: `M0 0h11v2H0zm4 11h3V6h4V4H0v2h4zm11.5 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0-2.99a.5.5 0 0 1 0 .99c-.28 0-.5-.22-.5-.5s.22-.49.5-.49m6 5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 2.99a.5.5 0 0 1-.5-.5.5.5 0 0 1 1 .01.5.5 0 0 1-.5.49m.5-9l-9 9 1.51 1.5 9-9zm-5-2c2.2 0 4-1.12 4-2.5V2s.98-.16 1.5.95C23 4.05 23 6 23 6s1-1.12 1-3.13C24-.02 21 0 21 0h-2v6.35A5.85 5.85 0 0 0 17 6c-2.2 0-4 1.12-4 2.5s1.8 2.5 4 2.5m-6.7 9.48L8.82 18.9a47.54 47.54 0 0 1-1.44 1.13c-.3-.3-.99-1.02-2.04-2.19.9-.83 1.47-1.46 1.72-1.89s.38-.87.38-1.33c0-.6-.27-1.18-.82-1.76-.54-.58-1.33-.87-2.35-.87-1 0-1.79.29-2.34.87-.56.6-.83 1.18-.83 1.79 0 .81.42 1.75 1.25 2.8a6.57 6.57 0 0 0-1.8 1.79 3.46 3.46 0 0 0-.51 1.83c0 .86.3 1.56.92 2.1a3.5 3.5 0 0 0 2.42.83c1.17 0 2.44-.38 3.81-1.14L8.23 24h2.82l-2.09-2.38 1.34-1.14zM3.56 14.1a1.02 1.02 0 0 1 .73-.28c.31 0 .56.08.75.25a.85.85 0 0 1 .28.66c0 .52-.42 1.11-1.26 1.78-.53-.65-.8-1.23-.8-1.74a.9.9 0 0 1 .3-.67m.18 7.9c-.43 0-.78-.12-1.06-.35-.28-.23-.41-.49-.41-.76 0-.6.5-1.3 1.52-2.09a31.23 31.23 0 0 0 2.25 2.44c-.92.5-1.69.76-2.3.76`
};
const search = {
  search: `M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z`,
  delete: `M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z`
};
const I18N = {
  search: 'Search',
  emojilist: 'List of emoji',
  notfound: 'No Emoji Found',
  clear: 'Clear',
  categories: {
    search: 'Search Results',
    recent: 'Frequently Used',
    people: 'Smileys & People',
    nature: 'Animals & Nature',
    foods: 'Food & Drink',
    activity: 'Activity',
    places: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    custom: 'Custom'
  },
  skintones: {
    1: 'Default Skin Tone',
    2: 'Light Skin Tone',
    3: 'Medium-Light Skin Tone',
    4: 'Medium Skin Tone',
    5: 'Medium-Dark Skin Tone',
    6: 'Dark Skin Tone'
  }
};
let PickerComponent = /*#__PURE__*/(() => {
  class PickerComponent {
    constructor(ngZone, renderer, ref, frequently, platformId) {
      this.ngZone = ngZone;
      this.renderer = renderer;
      this.ref = ref;
      this.frequently = frequently;
      this.platformId = platformId;
      this.perLine = 9;
      this.totalFrequentLines = 4;
      this.i18n = {};
      this.style = {};
      this.title = 'Emoji Mart™';
      this.emoji = 'department_store';
      this.darkMode = !!(typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches);
      this.color = '#ae65c5';
      this.hideObsolete = true;
      /** all categories shown */
      this.categories = [];
      /** used to temporarily draw categories */
      this.activeCategories = [];
      this.set = 'apple';
      this.skin = 1;
      /** Renders the native unicode emoji */
      this.isNative = false;
      this.emojiSize = 24;
      this.sheetSize = 64;
      this.showPreview = true;
      this.emojiTooltip = false;
      this.autoFocus = false;
      this.custom = [];
      this.hideRecent = true;
      this.notFoundEmoji = 'sleuth_or_spy';
      this.categoriesIcons = categories;
      this.searchIcons = search;
      this.useButton = false;
      this.enableFrequentEmojiSort = false;
      this.enableSearch = true;
      this.showSingleCategory = false;
      this.virtualize = false;
      this.virtualizeOffset = 0;
      this.emojiClick = new EventEmitter();
      this.emojiSelect = new EventEmitter();
      this.skinChange = new EventEmitter();
      this.scrollHeight = 0;
      this.clientHeight = 0;
      this.clientWidth = 0;
      this.firstRender = true;
      this.animationFrameRequestId = null;
      this.NAMESPACE = 'emoji-mart';
      this.measureScrollbar = 0;
      this.RECENT_CATEGORY = {
        id: 'recent',
        name: 'Recent',
        emojis: null
      };
      this.SEARCH_CATEGORY = {
        id: 'search',
        name: 'Search',
        emojis: null,
        anchor: false
      };
      this.CUSTOM_CATEGORY = {
        id: 'custom',
        name: 'Custom',
        emojis: []
      };
      this.backgroundImageFn = (set, sheetSize) => `https://unpkg.com/emoji-datasource-${this.set}@6.0.1/img/${this.set}/sheets-256/${this.sheetSize}.png`;
    }
    ngOnInit() {
      // measure scroll
      this.measureScrollbar = measureScrollbar();
      this.i18n = {
        ...I18N,
        ...this.i18n
      };
      this.i18n.categories = {
        ...I18N.categories,
        ...this.i18n.categories
      };
      this.skin = JSON.parse(isPlatformBrowser(this.platformId) && localStorage.getItem(`${this.NAMESPACE}.skin`) || 'null') || this.skin;
      const allCategories = [...categories$1];
      if (this.custom.length > 0) {
        this.CUSTOM_CATEGORY.emojis = this.custom.map(emoji => {
          return {
            ...emoji,
            // `<Category />` expects emoji to have an `id`.
            id: emoji.shortNames[0],
            custom: true
          };
        });
        allCategories.push(this.CUSTOM_CATEGORY);
      }
      if (this.include !== undefined) {
        allCategories.sort((a, b) => {
          if (this.include.indexOf(a.id) > this.include.indexOf(b.id)) {
            return 1;
          }
          return -1;
        });
      }
      for (const category of allCategories) {
        const isIncluded = this.include && this.include.length ? this.include.indexOf(category.id) > -1 : true;
        const isExcluded = this.exclude && this.exclude.length ? this.exclude.indexOf(category.id) > -1 : false;
        if (!isIncluded || isExcluded) {
          continue;
        }
        if (this.emojisToShowFilter) {
          const newEmojis = [];
          const {
            emojis
          } = category;
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for (let emojiIndex = 0; emojiIndex < emojis.length; emojiIndex++) {
            const emoji = emojis[emojiIndex];
            if (this.emojisToShowFilter(emoji)) {
              newEmojis.push(emoji);
            }
          }
          if (newEmojis.length) {
            const newCategory = {
              emojis: newEmojis,
              name: category.name,
              id: category.id
            };
            this.categories.push(newCategory);
          }
        } else {
          this.categories.push(category);
        }
        this.categoriesIcons = {
          ...categories,
          ...this.categoriesIcons
        };
        this.searchIcons = {
          ...search,
          ...this.searchIcons
        };
      }
      const includeRecent = this.include && this.include.length ? this.include.indexOf(this.RECENT_CATEGORY.id) > -1 : true;
      const excludeRecent = this.exclude && this.exclude.length ? this.exclude.indexOf(this.RECENT_CATEGORY.id) > -1 : false;
      if (includeRecent && !excludeRecent) {
        this.hideRecent = false;
        this.categories.unshift(this.RECENT_CATEGORY);
      }
      if (this.categories[0]) {
        this.categories[0].first = true;
      }
      this.categories.unshift(this.SEARCH_CATEGORY);
      this.selected = this.categories.filter(category => category.first)[0].name;
      // Need to be careful if small number of categories
      const categoriesToLoadFirst = Math.min(this.categories.length, 3);
      this.setActiveCategories(this.activeCategories = this.categories.slice(0, categoriesToLoadFirst));
      // Trim last active category
      const lastActiveCategoryEmojis = this.categories[categoriesToLoadFirst - 1].emojis.slice();
      this.categories[categoriesToLoadFirst - 1].emojis = lastActiveCategoryEmojis.slice(0, 60);
      setTimeout(() => {
        // Restore last category
        this.categories[categoriesToLoadFirst - 1].emojis = lastActiveCategoryEmojis;
        this.setActiveCategories(this.categories);
        // The `setTimeout` will trigger the change detection, but since we're inside
        // the OnPush component we can run change detection locally starting from this
        // component and going down to the children.
        this.ref.detectChanges();
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        isPlatformBrowser(this.platformId) && this.ngZone.runOutsideAngular(() => {
          // The `updateCategoriesSize` doesn't change properties that are used
          // in templates, thus this is run in the context of the root zone to avoid
          // running change detection.
          requestAnimationFrame(() => {
            this.updateCategoriesSize();
          });
        });
      });
      this.ngZone.runOutsideAngular(() => {
        // DOM events that are listened by Angular inside the template trigger change detection
        // and also wrapped into additional functions that call `markForCheck()`. We listen `scroll`
        // in the context of the root zone since it will not trigger change detection each time
        // the `scroll` event is dispatched.
        this.scrollListener = this.renderer.listen(this.scrollRef.nativeElement, 'scroll', () => {
          this.handleScroll();
        });
      });
    }
    ngOnDestroy() {
      this.scrollListener?.();
      // This is called here because the component might be destroyed
      // but there will still be a `requestAnimationFrame` callback in the queue
      // that calls `detectChanges()` on the `ViewRef`. This will lead to a runtime
      // exception if the `detectChanges()` is called after the `ViewRef` is destroyed.
      this.cancelAnimationFrame();
    }
    setActiveCategories(categoriesToMakeActive) {
      if (this.showSingleCategory) {
        this.activeCategories = categoriesToMakeActive.filter(x => x.name === this.selected || x === this.SEARCH_CATEGORY);
      } else {
        this.activeCategories = categoriesToMakeActive;
      }
    }
    updateCategoriesSize() {
      this.categoryRefs.forEach(component => component.memoizeSize());
      if (this.scrollRef) {
        const target = this.scrollRef.nativeElement;
        this.scrollHeight = target.scrollHeight;
        this.clientHeight = target.clientHeight;
        this.clientWidth = target.clientWidth;
      }
    }
    handleAnchorClick($event) {
      this.updateCategoriesSize();
      this.selected = $event.category.name;
      this.setActiveCategories(this.categories);
      if (this.SEARCH_CATEGORY.emojis) {
        this.handleSearch(null);
        this.searchRef?.clear();
        this.handleAnchorClick($event);
        return;
      }
      const component = this.categoryRefs.find(n => n.id === $event.category.id);
      if (component) {
        let {
          top
        } = component;
        if ($event.category.first) {
          top = 0;
        } else {
          top += 1;
        }
        this.scrollRef.nativeElement.scrollTop = top;
      }
      this.nextScroll = $event.category.name;
      // handle component scrolling to load emojis
      for (const category of this.categories) {
        const componentToScroll = this.categoryRefs.find(({
          id
        }) => id === category.id);
        componentToScroll?.handleScroll(this.scrollRef.nativeElement.scrollTop);
      }
    }
    categoryTrack(index, item) {
      return item.id;
    }
    handleScroll(noSelectionChange = false) {
      if (this.nextScroll) {
        this.selected = this.nextScroll;
        this.nextScroll = undefined;
        this.ref.detectChanges();
        return;
      }
      if (!this.scrollRef) {
        return;
      }
      if (this.showSingleCategory) {
        return;
      }
      let activeCategory;
      if (this.SEARCH_CATEGORY.emojis) {
        activeCategory = this.SEARCH_CATEGORY;
      } else {
        const target = this.scrollRef.nativeElement;
        // check scroll is not at bottom
        if (target.scrollTop === 0) {
          // hit the TOP
          activeCategory = this.categories.find(n => n.first === true);
        } else if (target.scrollHeight - target.scrollTop === this.clientHeight) {
          // scrolled to bottom activate last category
          activeCategory = this.categories[this.categories.length - 1];
        } else {
          // scrolling
          for (const category of this.categories) {
            const component = this.categoryRefs.find(({
              id
            }) => id === category.id);
            const active = component?.handleScroll(target.scrollTop);
            if (active) {
              activeCategory = category;
            }
          }
        }
        this.scrollTop = target.scrollTop;
      }
      // This will allow us to run the change detection only when the category changes.
      if (!noSelectionChange && activeCategory && activeCategory.name !== this.selected) {
        this.selected = activeCategory.name;
        this.ref.detectChanges();
      } else if (noSelectionChange) {
        this.ref.detectChanges();
      }
    }
    handleSearch($emojis) {
      this.SEARCH_CATEGORY.emojis = $emojis;
      for (const component of this.categoryRefs.toArray()) {
        if (component.name === 'Search') {
          component.emojis = $emojis;
          component.updateDisplay($emojis ? 'block' : 'none');
        } else {
          component.updateDisplay($emojis ? 'none' : 'block');
        }
      }
      this.scrollRef.nativeElement.scrollTop = 0;
      this.handleScroll();
    }
    handleEnterKey($event, emoji) {
      if (!emoji) {
        if (this.SEARCH_CATEGORY.emojis !== null && this.SEARCH_CATEGORY.emojis.length) {
          emoji = this.SEARCH_CATEGORY.emojis[0];
          if (emoji) {
            this.emojiSelect.emit({
              $event,
              emoji
            });
          } else {
            return;
          }
        }
      }
      if (!this.hideRecent && !this.recent && emoji) {
        this.frequently.add(emoji);
      }
      const component = this.categoryRefs.toArray()[1];
      if (component && this.enableFrequentEmojiSort) {
        component.updateRecentEmojis();
        component.ref.markForCheck();
      }
    }
    handleEmojiOver($event) {
      if (!this.showPreview || !this.previewRef) {
        return;
      }
      const emojiData = this.CUSTOM_CATEGORY.emojis.find(customEmoji => customEmoji.id === $event.emoji.id);
      if (emojiData) {
        $event.emoji = {
          ...emojiData
        };
      }
      this.previewEmoji = $event.emoji;
      this.cancelAnimationFrame();
      this.ref?.detectChanges();
    }
    handleEmojiLeave() {
      if (!this.showPreview || !this.previewRef) {
        return;
      }
      this.ngZone.runOutsideAngular(() => {
        this.animationFrameRequestId = requestAnimationFrame(() => {
          this.previewEmoji = null;
          this.ref.detectChanges();
        });
      });
    }
    handleEmojiClick($event) {
      this.emojiClick.emit($event);
      this.emojiSelect.emit($event);
      this.handleEnterKey($event.$event, $event.emoji);
    }
    handleSkinChange(skin) {
      this.skin = skin;
      localStorage.setItem(`${this.NAMESPACE}.skin`, String(skin));
      this.skinChange.emit(skin);
    }
    getWidth() {
      if (this.style && this.style.width) {
        return this.style.width;
      }
      return this.perLine * (this.emojiSize + 12) + 12 + 2 + this.measureScrollbar + 'px';
    }
    cancelAnimationFrame() {
      if (this.animationFrameRequestId !== null) {
        cancelAnimationFrame(this.animationFrameRequestId);
        this.animationFrameRequestId = null;
      }
    }
  }
  PickerComponent.ɵfac = function PickerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PickerComponent)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(EmojiFrequentlyService), i0.ɵɵdirectiveInject(PLATFORM_ID));
  };
  PickerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PickerComponent,
    selectors: [["emoji-mart"]],
    viewQuery: function PickerComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c3, 7);
        i0.ɵɵviewQuery(PreviewComponent, 5);
        i0.ɵɵviewQuery(SearchComponent, 5);
        i0.ɵɵviewQuery(CategoryComponent, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.searchRef = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.categoryRefs = _t);
      }
    },
    inputs: {
      perLine: "perLine",
      totalFrequentLines: "totalFrequentLines",
      i18n: "i18n",
      style: "style",
      title: "title",
      emoji: "emoji",
      darkMode: "darkMode",
      color: "color",
      hideObsolete: "hideObsolete",
      categories: "categories",
      activeCategories: "activeCategories",
      set: "set",
      skin: "skin",
      isNative: "isNative",
      emojiSize: "emojiSize",
      sheetSize: "sheetSize",
      emojisToShowFilter: "emojisToShowFilter",
      showPreview: "showPreview",
      emojiTooltip: "emojiTooltip",
      autoFocus: "autoFocus",
      custom: "custom",
      hideRecent: "hideRecent",
      imageUrlFn: "imageUrlFn",
      include: "include",
      exclude: "exclude",
      notFoundEmoji: "notFoundEmoji",
      categoriesIcons: "categoriesIcons",
      searchIcons: "searchIcons",
      useButton: "useButton",
      enableFrequentEmojiSort: "enableFrequentEmojiSort",
      enableSearch: "enableSearch",
      showSingleCategory: "showSingleCategory",
      virtualize: "virtualize",
      virtualizeOffset: "virtualizeOffset",
      recent: "recent",
      backgroundImageFn: "backgroundImageFn"
    },
    outputs: {
      emojiClick: "emojiClick",
      emojiSelect: "emojiSelect",
      skinChange: "skinChange"
    },
    decls: 8,
    vars: 16,
    consts: [["scrollRef", ""], [3, "ngStyle"], [1, "emoji-mart-bar"], [3, "anchorClick", "categories", "color", "selected", "i18n", "icons"], [3, "i18n", "include", "exclude", "custom", "autoFocus", "icons", "emojisToShowFilter", "searchResults", "enterKey", 4, "ngIf"], [1, "emoji-mart-scroll"], [3, "id", "name", "emojis", "perLine", "totalFrequentLines", "hasStickyPosition", "i18n", "hideObsolete", "notFoundEmoji", "custom", "recent", "virtualize", "virtualizeOffset", "emojiIsNative", "emojiSkin", "emojiSize", "emojiSet", "emojiSheetSize", "emojiForceSize", "emojiTooltip", "emojiBackgroundImageFn", "emojiImageUrlFn", "emojiUseButton", "emojiOver", "emojiLeave", "emojiClick", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "emoji-mart-bar", 4, "ngIf"], [3, "searchResults", "enterKey", "i18n", "include", "exclude", "custom", "autoFocus", "icons", "emojisToShowFilter"], [3, "emojiOver", "emojiLeave", "emojiClick", "id", "name", "emojis", "perLine", "totalFrequentLines", "hasStickyPosition", "i18n", "hideObsolete", "notFoundEmoji", "custom", "recent", "virtualize", "virtualizeOffset", "emojiIsNative", "emojiSkin", "emojiSize", "emojiSet", "emojiSheetSize", "emojiForceSize", "emojiTooltip", "emojiBackgroundImageFn", "emojiImageUrlFn", "emojiUseButton"], [3, "skinChange", "emoji", "idleEmoji", "emojiIsNative", "emojiSize", "emojiSkin", "emojiSet", "i18n", "emojiSheetSize", "emojiBackgroundImageFn", "emojiImageUrlFn"]],
    template: function PickerComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "section", 1)(1, "div", 2)(2, "emoji-mart-anchors", 3);
        i0.ɵɵlistener("anchorClick", function PickerComponent_Template_emoji_mart_anchors_anchorClick_2_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.handleAnchorClick($event));
        });
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(3, PickerComponent_emoji_search_3_Template, 1, 7, "emoji-search", 4);
        i0.ɵɵelementStart(4, "section", 5, 0);
        i0.ɵɵtemplate(6, PickerComponent_emoji_category_6_Template, 1, 23, "emoji-category", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, PickerComponent_div_7_Template, 2, 11, "div", 7);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("emoji-mart ", ctx.darkMode ? "emoji-mart-dark" : "", "");
        i0.ɵɵstyleProp("width", ctx.getWidth());
        i0.ɵɵproperty("ngStyle", ctx.style);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("categories", ctx.categories)("color", ctx.color)("selected", ctx.selected)("i18n", ctx.i18n)("icons", ctx.categoriesIcons);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.enableSearch);
        i0.ɵɵadvance();
        i0.ɵɵattribute("aria-label", ctx.i18n.emojilist);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.activeCategories)("ngForTrackBy", ctx.categoryTrack);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showPreview);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i2.NgStyle, AnchorsComponent, CategoryComponent, SearchComponent, PreviewComponent],
    encapsulation: 2,
    changeDetection: 0
  });
  return PickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PickerModule = /*#__PURE__*/(() => {
  class PickerModule {}
  PickerModule.ɵfac = function PickerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PickerModule)();
  };
  PickerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: PickerModule
  });
  PickerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, FormsModule, EmojiModule]
  });
  return PickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AnchorsComponent, CategoryComponent, EmojiFrequentlyService, EmojiSearch, PickerComponent, PickerModule, PreviewComponent, SearchComponent, SkinComponent };
